
import Condition from '@/components/leads/enums/valuation/Condition'
import Quality from '@/components/leads/enums/valuation/Quality'
import Reason from '@/components/leads/enums/valuation/Reason'
import { i18n } from '@/plugins/i18n'

const localizedMap = (baseKey, keys) => Object.defineProperties({}, Object.fromEntries(keys.map(key => [
  key,
  { enumerable: true, get: () => i18n.t(`${baseKey}.${key}`) }
])))

export const readableCondition = localizedMap('enums.valuation.condition', Object.values(Condition))

export const readableQuality = localizedMap('enums.valuation.quality', Object.values(Quality))

export const readableReason = localizedMap('enums.valuation.reason', Object.values(Reason))
